module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page-2"
    }
  }), _c('em', [_vm._v("For Dave Duncan, a scholar, a gentleman,"), _c('br'), _vm._v(" and a damned fine writer."), _c('br'), _vm._v(" Thanks for all the fabulous reads—and lunch."), _c('br'), _vm._v(" Here’s to many more!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c20ec9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface004.vue
// module id = 69
// module chunks = 0